import PropTypes from 'prop-types';
import React from 'react';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router';

import CheckoutModal from '../containers/CheckoutModal';
import withToggle from '../../hoc/WithToggle';
import { FontsPreloader } from './CheckoutModal';
import { withNewCheckoutButton } from '../containers/withNewCheckoutButton';

const WaitingListButton = ({
  disabled,
  on,
  off,
  formDisabled,
  onSuccess,
  toggled,
  children,
  className,
  panelLabel,
}) => (
  <div>
    <FontsPreloader />
    <button
      className={className}
      type="button"
      disabled={disabled || formDisabled}
      onClick={on}
    >
      {children}
    </button>
    <CheckoutModal
      onSuccess={onSuccess}
      off={off}
      panelLabel={panelLabel}
      toggled={toggled}
    />
  </div>
);

WaitingListButton.propTypes = {
  formDisabled: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  toggled: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func.isRequired,
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  children: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  panelLabel: PropTypes.string.isRequired,
};

export default compose(
  withProps(() => ({
    children: 'Put me on a waiting list',
    className: 'c-btn c-btn--primary u-1/1 u-mb- delta',
    panelLabel: 'Process',
  })),
  withNewCheckoutButton,
  withRouter,
  withToggle,
)(WaitingListButton);




// WEBPACK FOOTER //
// ./src/app/reservation/components/WaitingListButton.jsx